import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { ShoppingBag, RefreshCw, Unplug, Link2 } from "lucide-react";

const empty = { shop_domain: "", client_id: "", client_secret: "", access_token: "" };

const Field = ({ label, hint, ...p }) => (
  <div><label className="label-caps block mb-2">{label}</label>
    <input className="input-dark" {...p}/>{hint && <div className="text-xs opacity-60 mt-1">{hint}</div>}</div>
);

export function ShopifyConnectCard() {
  const [st, setSt] = useState(null);
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const load = () => api.get("/shopify/status").then(r => setSt(r.data));
  useEffect(() => { load(); }, []);

  const run = async (fn) => {
    setBusy(true); setErr(""); setMsg("");
    try { await fn(); } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
    setBusy(false);
  };
  const connect = () => run(async () => {
    await api.post("/shopify/connect", { ...f, webhook_base: process.env.REACT_APP_BACKEND_URL });
    setF(empty); setMsg("Negozio collegato: i nuovi ordini arriveranno in automatico."); await load();
  });
  const sync = () => run(async () => {
    const r = await api.post("/shopify/sync");
    setMsg(`Letti ${r.data.fetched} ordini da Shopify, ${r.data.created} nuovi importati.`); await load();
  });
  const disconnect = () => window.confirm("Scollegare Shopify? Gli ordini già importati restano.") &&
    run(async () => { await api.delete("/shopify/connect"); await load(); });

  if (!st) return null;
  return (
    <div className="card-dark p-6 space-y-4 max-w-2xl" data-testid="shopify-card">
      <div className="flex items-center gap-3"><ShoppingBag size={16}/><div className="label-caps">Shopify</div></div>
      {st.connected ? (
        <>
          <div className="text-sm space-y-1" data-testid="shopify-connected">
            <div><b>{st.shop_name || st.shop_domain}</b> · {st.shop_domain}</div>
            <div className="opacity-70">Ordini importati: {st.orders_imported || 0}{st.last_order_at ? ` · ultimo ${st.last_order_at.slice(0, 16).replace("T", " ")}` : ""}</div>
            <div className="opacity-70">Aggiornamento automatico: {st.webhooks?.length ? "attivo" : "non attivo"}</div>
          </div>
          <div className="flex gap-3">
            <button data-testid="shopify-sync" disabled={busy} onClick={sync} className="btn-gold inline-flex items-center gap-2"><RefreshCw size={14}/> Importa ultimi ordini</button>
            <button data-testid="shopify-disconnect" disabled={busy} onClick={disconnect} className="btn-ghost inline-flex items-center gap-2"><Unplug size={14}/> Scollega</button>
          </div>
        </>
      ) : (
        <>
          <p className="text-sm opacity-70">
            Crea un'app dal Dev Dashboard di Shopify (dev.shopify.com) con i permessi <code>read_orders</code> e <code>read_customers</code>,
            installala sul tuo negozio e incolla qui Client ID e Client Secret. Se hai una vecchia app personalizzata, usa invece il suo Admin API access token e la API secret key.
            I prodotti vengono riconosciuti dallo SKU: deve iniziare con il codice del capo (es. JK-001 oppure JK-001-M-NERO).
          </p>
          <Field label="Dominio negozio" placeholder="mio-negozio.myshopify.com" data-testid="shopify-domain" value={f.shop_domain} onChange={e => setF({ ...f, shop_domain: e.target.value })}/>
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Client ID" data-testid="shopify-client-id" value={f.client_id} onChange={e => setF({ ...f, client_id: e.target.value })}/>
            <Field label="Client Secret / API secret key" type="password" data-testid="shopify-client-secret" value={f.client_secret} onChange={e => setF({ ...f, client_secret: e.target.value })}/>
          </div>
          <Field label="Admin API access token (solo app vecchie)" type="password" hint="Lascia vuoto se usi Client ID e Client Secret." data-testid="shopify-access-token" value={f.access_token} onChange={e => setF({ ...f, access_token: e.target.value })}/>
          <button data-testid="shopify-connect" disabled={busy || !f.shop_domain || !f.client_secret} onClick={connect} className="btn-gold inline-flex items-center gap-2"><Link2 size={14}/> {busy ? "Collegamento…" : "Collega Shopify"}</button>
        </>
      )}
      {err && <div className="text-red-600 text-sm" data-testid="shopify-error">{err}</div>}
      {msg && <div className="text-green-700 text-sm" data-testid="shopify-msg">{msg}</div>}
    </div>
  );
}
